export default __webpack_public_path__ + "static/media/logo-superfin.9d3a2f40.png";